
import {Vue} from "vue-class-component";
import {Prop} from "vue-property-decorator";

export default class ContentTextBlock extends Vue {
  @Prop({type: String, default: null}) textContent: string;
}
